/*Filter if the view have a input search bar but doesn't have items in the list
 hide the search bar and show a message of "No records to display"*/

var listToSearch, itemOfList, lengthOfList, containerMessage, searchContainer;
listToSearch = document.getElementById("list_to_search");

if (listToSearch !== null && listToSearch !== null && itemOfList !== null && itemOfList !== undefined) {
    itemOfList = listToSearch.getElementsByTagName("li");
    lengthOfList = itemOfList.length;
    containerMessage = document.getElementById("message-no-items-found");
    searchContainer = document.getElementById("search_container");
    if (lengthOfList === 0) {
        toggleContainerMessage("hide", "show");
    }
    else {
        toggleContainerMessage("show", "hide");
    }
}

function toggleContainerMessage(stateToRemove, stateToAdd) {
    if (searchContainer !== null && searchContainer !== undefined) {
        document.getElementById("search_container").classList.add(stateToRemove);
        if (containerMessage !== null && containerMessage !== undefined) {
            containerMessage.classList.remove(stateToRemove);
            containerMessage.classList.add(stateToAdd);
        }
    }
}


/*Clear input of search when an item of the list is selected*/
if (listToSearch !== null && itemOfList !== null && lengthOfList > 0) {
    itemOfList.onclick = function () {
        (<HTMLInputElement>document.getElementById("input_search")).value = "";
    };
}


/*Search functionality for the items of a list. The search is made by one caracter,
and if any element match the search parameter a a message of "No records to display" is show*/
if ((document.getElementById("input_search")) !== null) {
    document.getElementById("input_search").onkeyup = function () { searchBar() };
}
function searchBar() {
    var input, filter, listToSearch, itemOfList, length, h4, h5, h6, i, counterNotFound, containerMessage;
    containerMessage = document.getElementById('message-no-items-found');
    input = document.getElementById("input_search");
    filter = input.value.toUpperCase();
    listToSearch = document.getElementById("list_to_search");
    itemOfList = listToSearch.getElementsByTagName("li");
    length = itemOfList.length;
    counterNotFound = 0;
    for (i = 0; i < length; i++) {
        h4 = itemOfList[i].getElementsByTagName("h4")[0];
        h5 = itemOfList[i].getElementsByTagName("h5")[0];
        h6 = itemOfList[i].getElementsByTagName("h6")[0];

        var h4Condition = (h4 !== null && h4 !== undefined && h4.innerHTML.toUpperCase().indexOf(filter) > -1);
        var h5Condition = (h5 !== null && h5 !== undefined && h5.innerHTML.toUpperCase().indexOf(filter) > -1);
        var h6Condition = (h6 !== null && h6 !== undefined && h6.innerHTML.toUpperCase().indexOf(filter) > -1);

        if (!h4Condition && !h5Condition && !h6Condition) {
            counterNotFound++;
            itemOfList[i].style.display = "none";
        }
        else {
            itemOfList[i].style.display = "";
        }
    }

    containerMessage.classList.remove((counterNotFound === length) ? 'hide' : 'show');
    containerMessage.classList.add((counterNotFound === length) ? 'show' : 'hide');
};